import React from "react";

type FileTextIconProps = React.SVGProps<SVGSVGElement> & { color?: string };

export const FileTextIcon = ({ width = 24, height = 24, color = "#79808A", ...props }: FileTextIconProps) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6zM14 2v6h6M16 13H8M16 17H8M10 9H8" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default FileTextIcon;
